import React from "react";
import { ColDef, GridOptions, SelectionChangedEvent, RowNode, ValueGetterParams, Column } from "ag-grid-community";
import { DEBUG_MODE } from "../../utils/developer";
import { getFormattedColValue } from "./data-formatters";
import { UINoData } from "../ui/UIComponents";

export const DEFAULT_FILTER_PARAMS = {
	inRangeInclusive: true,
	clearButton: true,
};

function isNumeric(valueA, valueB): boolean {
	if (!valueA && !valueB) return true; // no values or zero
	// existing value and either isn't a valid number
	if ((!!valueA && isNaN(valueA)) || (!!valueB && isNaN(valueB))) {
		return false;
	}
	return true;
}

export const DEFAULT_GRID_OPTIONS = (component): GridOptions => {
	return {
		defaultColDef: {
			resizable: true,
			sortable: true,
			filter: "agTextColumnFilter",
			// rowGroup: true, // do grouping
			// enableRowGroup: true, // enterprise only
			filterParams: DEFAULT_FILTER_PARAMS,
			singleClickEdit: false,
		},
		autoGroupColumnDef: {
			comparator: (valueA, valueB, nodeA: RowNode, nodeB: RowNode, isInverted: boolean) => {
				// figure out if string by data type, no other way
				if ((typeof valueA === "string" || typeof valueB === "string") && !isNumeric(valueA, valueB)) {
					const valueAStr: string = valueA || "";
					return valueAStr.localeCompare(valueB || "");
				}
				return (valueA || -1) - (valueB || -1);
			},
			filterValueGetter: (params: ValueGetterParams) => {
				const groupedColumns: Column[] = component.groupedColumns;
				if (!groupedColumns.length || !params.data) return undefined;
				// get value from any of the grouped fields
				let value: any;
				groupedColumns.forEach((col: Column) => {
					value = getFormattedColValue(col.getColDef() as ColDef, params.data, false, true);
					if (value) return value;
				});
				return value;
			},
			filter: "agTextColumnFilter",
			filterParams: DEFAULT_FILTER_PARAMS,
		},
		enableColResize: true,
		suppressPropertyNamesCheck: true,
		debug: DEBUG_MODE,
		suppressDragLeaveHidesColumns: true,
		rowGroupPanelShow: "always", // always, never
		pivotMode: false,
		rememberGroupStateWhenNewData: true,
		pivotPanelShow: "onlyWhenPivoting", // on of ['always','onlyWhenPivoting']
		pivotColumnGroupTotals: "before",
		pivotRowTotals: "before",
		enterMovesDown: false,
		enterMovesDownAfterEdit: true,
		rowDragManaged: true,
		floatingFilter: true, // toggle this property to remove filter from column top
		allowShowChangeAfterFilter: true,
		multiSortKey: "ctrl",
		rowSelection: "multiple", // one of ['single','multiple'], leave blank for no selection
		rowDeselection: true,
		noRowsOverlayComponentFramework: () => <UINoData msg={component.props.noDataMsg} />,
		// quickFilterText: null,
		groupSelectsChildren: true, // one of [true, false]
		suppressRowClickSelection: true,
		enableCellTextSelection: true,
		suppressCopyRowsToClipboard: false,
		suppressColumnMoveAnimation: true,
		animateRows: false,
		defaultExportParams: {
			// dana
			columnGroups: true,
		},
		onSelectionChanged: onSelectionChanged.bind(component),
	};
};

export function onSelectionChanged(e: SelectionChangedEvent) {
	console.log("onSelectionChanged:", e);
	const selected: any[] = e.api.getSelectedRows();
	const selectedNodes: RowNode[] = e.api.getSelectedNodes();
	this.setState({ selected, selectedNodes });
}
